import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserInfoIfNeeded } from "../../api/features/user/actions";
import {
  getUserInfo,
  getUserInfoLoadStatus,
  getIsReferenceUser,
  getFullName,
  getReferenceId,
  isUserLoggedOut,
} from "../../api/features/user/selectors";

export default function useUser() {
  const loadStatus = useSelector(getUserInfoLoadStatus);
  const userInfo = useSelector(getUserInfo);
  const isReferenceUser = useSelector(getIsReferenceUser);
  const dispatch = useDispatch();
  const fullName = useSelector(getFullName);
  const referenceId = useSelector(getReferenceId);
  const isLoggedOut = useSelector(isUserLoggedOut);

  useEffect(() => {
    dispatch(fetchUserInfoIfNeeded());
  }, [dispatch]);

  return {
    loadStatus,
    userInfo,
    fullName,
    isReferenceUser,
    referenceId,
    isLoggedOut,
  };
}
